<div class="input-group input-group-sm">
  <div class="q-date" [ngClass]="[ input.QueovalCode !== 'DATE' && input.MainElementList[0].Mask !== 'd' ? 'col-5-minus-8px px-0' : 'col']">
    <input *ngIf="input.MainElementList[0].Visible" type="date" max="9999-12-31" [id]="input.MainElementList[0].ID" [ngModel]="input.MainElementList[0].ValueGeneric | date:'yyyy-MM-dd'"
           [disabled]="input.MainElementList[0].Disabled"
           class="q-input-border q-bo pl-2"
           [ngClass]="setClass(input)"
           aria-label="Small" aria-describedby="inputGroup-sizing-sm"
           (blur)="OnBlur($event.target.value)">
  </div>

  <ng-container *ngIf="input.QueovalCode !== 'DATE' && input.MainElementList[0].Mask !== 'd'">
    <select (change)="OnSelectChange($event.target.value, 'hour', input.MainElementList[1].SelectOptionsList)" class="q-main-select col-3 mx-auto">
      <option *ngFor="let option of input.MainElementList[1].SelectOptionsList" [value]="option.Value" [selected]="option.Selected">{{option.Text}}</option>
    </select>

    <select (change)="OnSelectChange($event.target.value, 'min', input.MainElementList[2].SelectOptionsList)" class="q-main-select col-3">
      <option *ngFor="let option of input.MainElementList[2].SelectOptionsList" [value]="option.Value" [selected]="option.Selected">{{option.Text}}</option>
    </select>
  </ng-container>

  <ng-container *ngFor="let button of input?.MainElementList?.slice(1)">
    <button *ngIf="button.Type === 'BUTTON'" class="q-btn q-bo q-main p-0" (click)="OnClickButton(button, ModalDatePicker);"
            [title]="button?.Tooltip ? button?.Tooltip : ''">
      <i class="{{button.Src}}"></i>
    </button>
  </ng-container>

</div>

<ng-template #ModalDatePicker let-modalDatePicker>
  <div #header class="modal-header">
    <h5 class="modal-title q-bold q-c-main" id="ModalTitle">Cycles Digital Learning</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalDatePicker.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body q-overflow" [style.height]="sanitizer.bypassSecurityTrustStyle('calc(100% - ' + header.offsetHeight + 'px)')">
    <q-cycle-elearning class="h-100" *ngIf="cycleElEntryPoint == 'tdoproduction'" [idStage]="model.IdDonneeFils" (save)="modalDatePicker.close('')" [model]="model"></q-cycle-elearning>
    <q-cycle-elearning class="h-100" *ngIf="cycleElEntryPoint == 'tdopersonne'" [idUser]="model.IdDonneeFils" (save)="modalDatePicker.close('')" [model]="model"></q-cycle-elearning>
    <!--<q-affecte-cycleel class="h-100" *ngIf="cycleElEntryPoint == 'tdopersonne'" [idLearner]="model.IdDonneeFils" (sendEvent)="modalDatePicker.close('')" (updateValueDateExp)=updateValueInput($event)></q-affecte-cycleel>-->
  </div>
  </ng-template>
